import util from "../util";
import Renderer from "../canvas/renderer";
import React from "preact/compat";

export default function GroupBarListItem(props: any) {
  let hasGroupSelected = false;
  const $elements = props.$elements;
  $elements.forEach(($el: any) => {
    if (util.isGroup($el) || util.isInGroup($el)) {
      hasGroupSelected = true
    }
  });

  function groupElements() {
    Renderer.group(props.$elements)
  }

  return null;

  // return <li className={hasGroupSelected ? 'hidden' : ''}>
  //   <a className="icn rwd-icon group-btn" onClick={groupElements}>
  //     <span>Group</span>
  //   </a>
  // </li>;
}
